import React from 'react';

import { NativeResources } from '@ariksa/inventory-core/api';

import { ECSContainers } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Containers/ECSContainers';
import { ContainerVulnerability } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Vulnerability/ContainerVulnerability/ContainerVulnerability';

export const getContainers = resourceType => {
  switch (resourceType) {
    case NativeResources.Ec2Instance:
      return <ContainerVulnerability />;
    case NativeResources.ElasticContainerService:
    case NativeResources.EcsCluster:
    case NativeResources.ElasticKubernetesService:
    case NativeResources.Gcpgke:
    case NativeResources.Aks:
      return <ECSContainers />;
    default:
      return null;
  }
};
